// extracted by mini-css-extract-plugin
export default {"summary-container":"BankReportSummary_summary-container__gjGMo","summary-ctas":"BankReportSummary_summary-ctas__X-e0j"};